/**
 * shadcn Label (Tailwind 3 "new-york"), ported per the checklist in
 * agents/CODING_STANDARDS.md -> "Styling: two systems", on a native
 * <label> rather than @radix-ui/react-label: the native element already does
 * everything the Radix one adds. Pass `htmlFor` with the control's `id`, or
 * wrap the control. `peer-disabled:` dims it next to a disabled `tw-peer`
 * control (Checkbox, RadioGroupItem, Switch). Add `tw-sr-only` where the
 * screen has no room for a visible label.
 */
import React from 'react'

import { cn } from '../../utils/cn.js'

const Label = React.forwardRef(
  ({ className, htmlFor, children, ...props }, ref) => (
    <label
      ref={ref}
      htmlFor={htmlFor}
      data-slot="label"
      className={cn(
        'tw-text-sm tw-font-medium tw-leading-none peer-disabled:tw-cursor-not-allowed peer-disabled:tw-opacity-70',
        className,
      )}
      {...props}
    >
      {children}
    </label>
  ),
)
Label.displayName = 'Label'

export { Label }
